export const formatDimensions = (pkg?: {
  length?: number | null
  width?: number | null
  height?: number | null
  weight?: number | null
}) => {
  const length = pkg?.length ?? 0
  const width = pkg?.width ?? 0
  const height = pkg?.height ?? 0
  const weight = pkg?.weight ?? 0

  const dimensionStr = `${length}cm × ${width}cm × ${height}cm`
  const weightStr = `${weight} kg`

  return `${dimensionStr} • ${weightStr}`
}
